import { AudioComponent } from "../webar-core/framework/AudioComponent";

function AudioLoadingComponent(props: any) {
  const defaultVolume = 1;
  const choiceVolume = 0.3;

  const gameSoundEffects: any[] = [
    <AudioComponent
      audio={{
        url: "https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/audios/compressedSoundEffect/Intro.mp3",
        name: "introSoundEffect",
        volume: defaultVolume,
      }}
      key={"introSoundEffect"}
    />,
    <AudioComponent
      audio={{
        url: "https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/audios/compressedSoundEffect/TapInstructions.mp3",
        name: "tapInstructionsSoundEffect",
        volume: defaultVolume,
      }}
      key={"tapInstructionsSoundEffect"}
    />,
    <AudioComponent
      audio={{
        url: "https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/audios/compressedSoundEffect/background-music.mp3",
        name: "backgroundMusic",
        volume: defaultVolume,
        loops: true,
      }}
      key={"backgroundMusic"}
    />,
    <AudioComponent
      audio={{
        url: "https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/audios/compressedSoundEffect/ageGateYesSoundEffect.mp3",
        name: "ageGateYesSoundEffect",
        volume: defaultVolume,
      }}
      key={"ageGateYesSoundEffect"}
    />,
    <AudioComponent
      audio={{
        url: "https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/audios/compressedSoundEffect/raycastSoundEffect.mp3",
        name: "raycastingTapSoundEffect",
        volume: defaultVolume,
      }}
      key={"raycastingTapSoundEffect"}
    />,
    <AudioComponent
      audio={{
        url: "https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/audios/compressedSoundEffect/shareButtonSoundEffect.mp3",
        name: "shareTapSoundEffect",
        volume: defaultVolume,
      }}
      key={"shareTapSoundEffect"}
    />,
    <AudioComponent
      audio={{
        url: "https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/audios/compressedSoundEffect/buttonTap.mp3",
        name: "shoppingTapSoundEffect",
        volume: defaultVolume,
      }}
      key={"shoppingTapSoundEffect"}
    />,
    <AudioComponent
      audio={{
        url: "https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/audios/compressedSoundEffect/prizeClick.mp3",
        name: "prizeTapSoundEffect",
        volume: defaultVolume,
      }}
      key={"prizeTapSoundEffect"}
    />,
    <AudioComponent
      audio={{
        url: "https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/audios/revision/18Bottle.mp3",
        name: "bottle18SoundEffect",
        volume: defaultVolume,
      }}
      key={"bottle18SoundEffect"}
    />,
    <AudioComponent
      audio={{
        url: "https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/audios/revision/18Cask.mp3",
        name: "cask18SoundEffect",
        volume: defaultVolume,
      }}
      key={"cask18SoundEffect"}
    />,
    <AudioComponent
      audio={{
        url: "https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/audios/revision/18Choice.mp3",
        name: "choice18SoundEffect",
        volume: choiceVolume,
      }}
      key={"choice18SoundEffect"}
    />,
    <AudioComponent
      audio={{
        url: "https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/audios/revision/18BottleBack.mp3",
        name: "back18SoundEffect",
        volume: defaultVolume,
      }}
      key={"back18SoundEffect"}
    />,
    <AudioComponent
      audio={{
        url: "https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/audios/revision/21Bottle.mp3",
        name: "bottle21SoundEffect",
        volume: defaultVolume,
      }}
      key={"bottle21SoundEffect"}
    />,
    <AudioComponent
      audio={{
        url: "https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/audios/revision/21Cask.mp3",
        name: "cask21SoundEffect",
        volume: defaultVolume,
      }}
      key={"cask21SoundEffect"}
    />,
    <AudioComponent
      audio={{
        url: "https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/audios/revision/21Choice.mp3",
        name: "choice21SoundEffect",
        volume: choiceVolume,
      }}
      key={"choice21SoundEffect"}
    />,
    <AudioComponent
      audio={{
        url: "https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/audios/revision/21BottleBack.mp3",
        name: "back21SoundEffect",
        volume: defaultVolume,
      }}
      key={"back21SoundEffect"}
    />,
    <AudioComponent
      audio={{
        url: "https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/audios/revision/25Bottle.mp3",
        name: "bottle25SoundEffect",
        volume: defaultVolume,
      }}
      key={"bottle25SoundEffect"}
    />,
    <AudioComponent
      audio={{
        url: "https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/audios/revision/25Cask.mp3",
        name: "cask25SoundEffect",
        volume: defaultVolume,
      }}
      key={"cask25SoundEffect"}
    />,
    <AudioComponent
      audio={{
        url: "https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/audios/revision/25Choice.mp3",
        name: "choice25SoundEffect",
        volume: choiceVolume,
      }}
      key={"choice25SoundEffect"}
    />,
    <AudioComponent
      audio={{
        url: "https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/audios/revision/25BottleBack.mp3",
        name: "back25SoundEffect",
        volume: defaultVolume,
      }}
      key={"back25SoundEffect"}
    />,
    <AudioComponent
      audio={{
        url: "https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/audios/revision/outroLoop.mp3",
        name: "outroLoop",
        volume: defaultVolume,
      }}
      key={"outroLoop"}
    />,
    <AudioComponent
      audio={{
        url: "https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/audios/revision/outroBigMoment.mp3",
        name: "outroBigMoment",
        volume: 0.5,
      }}
      key={"outroBigMoment"}
    />,
    <AudioComponent
      audio={{
        url: "https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/audios/revision/gemReward.mp3",
        name: "gemReward",
        volume: defaultVolume,
      }}
      key={"gemReward"}
    />,
  ];

  const defaultVoiceOvers: any[] = [
    <AudioComponent
      audio={{
        url: "https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/audios/voice_over_en/compressed/INTRO.mp3",
        name: "introVO",
        volume: defaultVolume,
      }}
      key={"introVO"}
    />,
    <AudioComponent
      audio={{
        url: "https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/audios/voice_over_en/compressed/IDLE_2.mp3",
        name: "idle2VO",
        volume: defaultVolume,
      }}
      key={"idle2VO"}
    />,
    <AudioComponent
      audio={{
        url: "https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/audios/voice_over_en/compressed/RING_INTRO.mp3",
        name: "ringsIntroVO",
        volume: defaultVolume,
      }}
      key={"ringsIntroVO"}
    />,
    <AudioComponent
      audio={{
        url: "https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/audios/voice_over_en/compressed/SURPRISE.mp3",
        name: "surpriseVO",
        volume: defaultVolume,
      }}
      key={"surpriseVO"}
    />,
    <AudioComponent
      audio={{
        url: "https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/audios/voice_over_en/compressed/18_MAIN.mp3",
        name: "main18VO",
        volume: defaultVolume,
      }}
      key={"main18VO"}
    />,
    <AudioComponent
      audio={{
        url: "https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/audios/voice_over_en/compressed/18_CHOICE.mp3",
        name: "choice18VO",
        volume: defaultVolume,
      }}
      key={"choice18VO"}
    />,
    <AudioComponent
      audio={{
        url: "https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/audios/voice_over_en/compressed/18_CASK.mp3",
        name: "cask18VO",
        volume: defaultVolume,
      }}
      key={"cask18VO"}
    />,
    <AudioComponent
      audio={{
        url: "https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/audios/voice_over_en/compressed/21_MAIN.mp3",
        name: "main21VO",
        volume: defaultVolume,
      }}
      key={"main21VO"}
    />,
    <AudioComponent
      audio={{
        url: "https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/audios/voice_over_en/compressed/21_CHOICE.mp3",
        name: "choice21VO",
        volume: defaultVolume,
      }}
      key={"choice21VO"}
    />,
    <AudioComponent
      audio={{
        url: "https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/audios/voice_over_en/compressed/21_CASK.mp3",
        name: "cask21VO",
        volume: defaultVolume,
      }}
      key={"cask21VO"}
    />,
    <AudioComponent
      audio={{
        url: "https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/audios/voice_over_en/compressed/25_MAIN.mp3",
        name: "main25VO",
        volume: defaultVolume,
      }}
      key={"main25VO"}
    />,
    <AudioComponent
      audio={{
        url: "https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/audios/voice_over_en/compressed/25_CHOICE.mp3",
        name: "choice25VO",
        volume: defaultVolume,
      }}
      key={"choice25VO"}
    />,
    <AudioComponent
      audio={{
        url: "https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/audios/voice_over_en/compressed/25_CASK.mp3",
        name: "cask25VO",
        volume: defaultVolume,
      }}
      key={"cask25VO"}
    />,
  ];

  const translatedVoiceOvers: any[] = [
    <AudioComponent
      audio={{
        url: "https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/audios/voice_over_cn/compressed/INTRO_cn.mp3",
        name: "introVO",
        volume: defaultVolume,
      }}
      key={"introVO"}
    />,
    <AudioComponent
      audio={{
        url: "https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/audios/voice_over_cn/compressed/IDLE_2_cn.mp3",
        name: "idle2VO",
        volume: defaultVolume,
      }}
      key={"idle2VO"}
    />,
    <AudioComponent
      audio={{
        url: "https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/audios/voice_over_cn/compressed/RINGS_INTRO_cn.mp3",
        name: "ringsIntroVO",
        volume: defaultVolume,
      }}
      key={"ringsIntroVO"}
    />,
    <AudioComponent
      audio={{
        url: "https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/audios/voice_over_cn/compressed/SURPRISE_cn.mp3",
        name: "surpriseVO",
        volume: defaultVolume,
      }}
      key={"surpriseVO"}
    />,
    <AudioComponent
      audio={{
        url: "https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/audios/voice_over_cn/compressed/18_MAIN_cn.mp3",
        name: "main18VO",
        volume: defaultVolume,
      }}
      key={"main18VO"}
    />,
    <AudioComponent
      audio={{
        url: "https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/audios/voice_over_cn/compressed/18_CHOICE_cn.mp3",
        name: "choice18VO",
        volume: defaultVolume,
      }}
      key={"choice18VO"}
    />,
    <AudioComponent
      audio={{
        url: "https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/audios/voice_over_cn/compressed/18_CASK_cn.mp3",
        name: "cask18VO",
        volume: defaultVolume,
      }}
      key={"cask18VO"}
    />,
    <AudioComponent
      audio={{
        url: "https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/audios/voice_over_cn/compressed/21_MAIN_cn.mp3",
        name: "main21VO",
        volume: defaultVolume,
      }}
      key={"main21VO"}
    />,
    <AudioComponent
      audio={{
        url: "https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/audios/voice_over_cn/compressed/21_CHOICE_cn.mp3",
        name: "choice21VO",
        volume: defaultVolume,
      }}
      key={"choice21VO"}
    />,
    <AudioComponent
      audio={{
        url: "https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/audios/voice_over_cn/compressed/21_CASK_cn.mp3",
        name: "cask21VO",
        volume: defaultVolume,
      }}
      key={"cask21VO"}
    />,
    <AudioComponent
      audio={{
        url: "https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/audios/voice_over_cn/compressed/25_MAIN_cn.mp3",
        name: "main25VO",
        volume: defaultVolume,
      }}
      key={"main25VO"}
    />,
    <AudioComponent
      audio={{
        url: "https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/audios/voice_over_cn/compressed/25_CHOICE_cn.mp3",
        name: "choice25VO",
        volume: defaultVolume,
      }}
      key={"choice25VO"}
    />,
    <AudioComponent
      audio={{
        url: "https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/audios/voice_over_cn/compressed/25_CASK_cn.mp3",
        name: "cask25VO",
        volume: defaultVolume,
      }}
      key={"cask25VO"}
    />,
  ];

  return (
    <>
      {gameSoundEffects}
      {!props.translate && defaultVoiceOvers}
      {props.translate && translatedVoiceOvers}
    </>
  );
}

export default AudioLoadingComponent;
